// src/utils/validation.js

// Normaliza el payload de una moto desde el form
export const normalizeMotoPayload = (form, id, fallbackFuente = "") => {
  // Asegura campos de sucursal canónicos con fallback a legacy `sucursal`
  const sucursalId =
    (form.sucursalId || "").toString().trim() ||
    (form.sucursal || "").toString().trim() ||
    "";

  const sucursalNombre =
    (form.sucursalNombre || "").toString().trim() ||
    // si no tenemos nombre, al menos usa el id legacy/canónico
    (form.sucursal || "").toString().trim() ||
    "";

  return {
    nombre: (form.nombre || "").trim(),
    codigoMoto: form.codigoMoto || id,
    marca: (form.marca || "").trim(),
    modelo: (form.modelo || "").trim(),
    ano: form.ano === "" ? null : Number(form.ano),
    color: (form.color || "").trim(),
    kilometros: form.kilometros === "" ? null : Number(form.kilometros),
    cilindrada: form.cilindrada === "" ? null : Number(form.cilindrada),
    valor: form.valor === "" ? null : Number(form.valor),

    // Si llega vacío/null → 0 (tu UI luego lo convierte a "" cuando corresponde)
    valorRebajado:
      form.valorRebajado === "" || form.valorRebajado == null
        ? 0
        : Number(form.valorRebajado),

    financiamiento: form.financiamiento === "Sí" ? "Sí" : "No",
    origen: form.origen === "Importada" ? "Importada" : "Nacional",
    tipoMoto: (form.tipoMoto || "").trim(),
    categoria: form.categoria === "Nueva" ? "Nueva" : "Seminueva",

    // 🔴 Campos canónicos de sucursal
    sucursalId,
    sucursalNombre,

    descripcion: form.descripcion ?? "",
    estatus: form.estatus ?? "pending",
    etiqueta: form.etiqueta ?? "",
    fuente: form.fuente || fallbackFuente || "",
    // Nuevo: guardar el id del producto de Freshsales/Freshworks si viene en el formulario
    idProductFreshsales: form.idProductFreshsales || form.idFreshworks || "",
  };
};

// Compara si cambió algún campo “clave” para disparar UPDATE webhook
export const detectTextoClaveCambio = (oldMoto, next) => {
  const oldAno = oldMoto?.ano ?? oldMoto?.año ?? null;
  const oldSucursalId = (oldMoto?.sucursalId || oldMoto?.sucursal || "").toString().trim();
  const oldSucursalNombre = (oldMoto?.sucursalNombre || oldMoto?.sucursal || "").toString().trim();

  return (
    (oldMoto?.nombre || "") !== next.nombre ||
    (oldMoto?.marca || "") !== next.marca ||
    (oldMoto?.modelo || "") !== next.modelo ||
    oldAno !== next.ano ||
    (oldMoto?.color || "") !== next.color ||
    ((oldMoto?.kilometros ?? null) !== next.kilometros) ||
    ((oldMoto?.cilindrada ?? null) !== next.cilindrada) ||
    ((oldMoto?.valor ?? null) !== next.valor) ||
    ((oldMoto?.valorRebajado ?? 0) !== (next.valorRebajado ?? 0)) ||
    (oldMoto?.financiamiento || "No") !== next.financiamiento ||
    (oldMoto?.origen || "Nacional") !== next.origen ||
    (oldMoto?.tipoMoto || "") !== next.tipoMoto ||
    (oldMoto?.categoria || "Seminueva") !== next.categoria ||

    // 🔴 Comparar por canónicos, con fallback a legacy
    oldSucursalId !== (next.sucursalId || "") ||
    oldSucursalNombre !== (next.sucursalNombre || "") ||

    (oldMoto?.descripcion || "") !== next.descripcion ||
    (oldMoto?.etiqueta || "") !== next.etiqueta ||
    (oldMoto?.estatus || "pending") !== next.estatus
  );
};

// Devuelve array con URLs de fotos existentes (1..7)
export const fotosArrayFromMoto = (m) =>
  [m?.foto1, m?.foto2, m?.foto3, m?.foto4, m?.foto5, m?.foto6, m?.foto7].filter(Boolean);